import { render, staticRenderFns } from "./BrandUploadedFilesComponent.vue?vue&type=template&id=33ad83e8&"
import script from "./BrandUploadedFilesComponent.vue?vue&type=script&lang=js&"
export * from "./BrandUploadedFilesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports